import { useQueryClient } from "@tanstack/react-query";

import useLocations from "../../data/useLocations";
import useVehiclesMutations from "../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import classNames from "../../utils/classNames";
import { IVehicle } from "../../models/Vehicle";

// Default styling — caller-supplied `classes` are merged AFTER so they
// can override width / padding / border as needed (e.g. the Job view card
// passes full-width form styling; dense tables pass `h-8 w-40 text-sm`).
const DEFAULT_SELECT_CLASSES =
  "border border-gray-300 rounded p-1 bg-white text-sm";

export default function VehicleLocationDropdown({
  vehicle,
  classes = "",
}: {
  vehicle: IVehicle;
  classes?: string;
}) {
  const queryClient = useQueryClient();
  const { locations } = useLocations();
  const { update } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("Vehicle Location");

  const handleLocationUpdate = (locationId: string) => {
    const updatedVehicle: IVehicle = {
      ...vehicle,
      locationId: locationId ? locationId : null,
    };

    update.mutate(updatedVehicle, {
      onSuccess: () => {
        queryClient.refetchQueries(["leads"]);
        saveHandlers.onSuccess();
      },
      onError: () => {
        saveHandlers.onError();
      },
    });
  };

  if (locations.isLoading) {
    return <></>;
  }

  return (
    <div
      className="flex h-full w-full items-center"
      onClick={(e) => e.stopPropagation()}
    >
      <select
        value={vehicle.locationId ? vehicle.locationId : ""}
        className={classNames(DEFAULT_SELECT_CLASSES, classes)}
        onChange={(e) => handleLocationUpdate(e.target.value)}
      >
        <option value="">No Location</option>
        {locations.data?.data &&
          locations.data?.data.map((location) => (
            <option key={location.id} value={location.id}>
              {location.name}
            </option>
          ))}
      </select>
    </div>
  );
}
